<template>
  <div class="product-card" @click="gotoDetail(item)">
    <div class="product-name">
      <div class="name" :title="item.prodtName">{{ item.prodtName }}</div>
      <el-tag v-if="showTag" size="small">{{ item.prodtTypeDsr }}</el-tag>
    </div>
    <div class="product-compamny">{{ item.crtUserNm }}</div>
    <div class="product-compamny">{{ item.contractPhone || '-' }}</div>
    <img class="product-img" :src="imgUrl" />
    <img
      v-if="needCollect"
      class="star-img"
      :src="item.isCollect ? require('@/assets/images/星星-active.png') : require('@/assets/images/星星.png')"
      alt=""
      @click.stop="collect(item)"
    />
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    needCollect: {
      type: Boolean,
      default: false,
    },
    showTag: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imgUrl() {
      let urls = (this.item.prodtPictureUrl || '').split(',')
      return urls[0]
    },
  },
  methods: {
    gotoDetail(item) {
      this.$router.push({ path: `/product/detail?id=${item.id}` })
    },
    collect(item) {
      let api = item.isCollect ? '/zzmh/in/product/unCollect' : '/zzmh/in/product/collect'
      this.$http({ method: 'get', url: `${api}?id=` + item.id })
        .then((res) => {
          this.$message.success('操作成功')
          this.$emit('refresh')
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="less" scoped>
.product-card {
  display: inline-block;
  cursor: pointer;
  position: relative;
  width: 225px;
  height: 199px;
  transition: transform 0.4s ease-in-out;
  background: #fff;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.02);
  border-radius: 10px;
  transition: all 0.3s;
  padding: 20px 30px;
  .product-name {
    display: flex;
    justify-content: space-between;
    .name {
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 600;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .product-compamny {
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 400;
    // margin-bottom: 8px;
  }
  .product-img {
    margin-top: 4px;
    width: 100%;
    object-fit: cover;
    height: 125px;
  }
  .star-img {
    cursor: pointer;
    position: absolute;
    right: 20px;
    top: 20px;
    width: 28px;
  }
  &:not(:last-child) {
    margin-right: 20px;
  }
}
</style>
